const SIGNED_IN = "SIGNED_IN";
const SIGNED_OUT = "SIGNED_OUT";
const USER_UPDATED = "USER_UPDATED";
const PASSWORD_RECOVERY = "PASSWORD_RECOVERY";

export const AUTH_EVENT = {
  SIGNED_IN,
  SIGNED_OUT,
  USER_UPDATED,
  PASSWORD_RECOVERY,
};
